import React from "react";
import CloseIcon from "../../../../Experimental/Icons/CloseIcon";
import Button from "../../../../Experimental/General/components/Button/Button";
import s from "./CloseButton.pcss";

export default function CloseButton({position, ...props}) {
    return (
        <Button
            data-test-id="overlay-close-button"
            round
            className={s.closeButton}
            style={{position}}
            iconOnly
            clear
            aria-label="Close modal"
            {...props}
        >
            <CloseIcon />
        </Button>
    );
}
